<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="dialog-content">
    <div class="footer-tools">
        <app-bulk-group-chooser  [formControl]="groupFilter"
        label="Names or Hawk Ids (press enter after each)" [selectedGroups]="selectedGroups"
        (groupsChange)="groupsChange($event)"></app-bulk-group-chooser>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <!-- <button mat-button (click)="cancel()" *ngIf="!data?.isNew">Done</button> -->
    <button mat-button (click)="cancel()">Cancel</button>
    <!-- <button mat-button color="primary" (click)="createGroup()" *ngIf="data?.isNew">Create</button> -->
    <button mat-stroked-button [disabled]="! groupFilter.value?.length" (click)="addGroups()"><mat-icon>add</mat-icon> Add selected groups(s)</button>
</mat-dialog-actions>